import { render, staticRenderFns } from "./DropMenu.vue?vue&type=template&id=b9b2cb96&"
import script from "./DropMenu.vue?vue&type=script&lang=js&"
export * from "./DropMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports